module.exports = __webpack_public_path__ + "static/media/clarissa.2411b12e.png";